/* Copyright (C) 2020 Carlo Capuano - All Rights Reserved
 * You may use, distribute and modify this code under the
 * terms of the MIT license.
 */
import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from 'src/app/global/monitoring.service';

@Injectable({
  providedIn: 'root',
})
export class MyErrorHandler implements ErrorHandler {
  constructor(private monitoringService: MonitoringService) {}
  handleError(error) {
    // do something with the exception
    console.log(error);
    this.monitoringService.logException(error);
  }
}
